import React from "react";
import GridContainer from "components/UI/Grid/GridContainer";
import GridItemTS from "components/UI/Grid/GridItemTS";
import { TabContent, TabSystem } from "components/UI/TabSystem";

import ActivityItemSettings from "views/List/ActivityItemSettings";
import { ProfileTab } from "enums/ProfileTabs";
import { useTranslation } from "react-i18next";

const ActivityItemSettingsTabs: React.FC = () => {
  const { t } = useTranslation("sidebar");
  const tabs = [
    {
      id: ProfileTab.SOWS,
      title: t(ProfileTab.SOWS),
    },
    {
      id: ProfileTab.WORKERS,
      title: t(ProfileTab.WORKERS),
    },
    {
      id: ProfileTab.EQUIPMENTS,
      title: t(ProfileTab.EQUIPMENTS),
    },
  ];

  return (
    <GridContainer>
      <GridItemTS xs={12} style={{ marginTop: "1rem" }}>
        <TabSystem tabs={tabs} syncWithUrlParams>
          <TabContent value={ProfileTab.SOWS}>
            <GridItemTS key="user-list-data" xs={12}>
              <ActivityItemSettings profile="sow" />
            </GridItemTS>
          </TabContent>
          <TabContent value={ProfileTab.WORKERS}>
            <GridItemTS key="user-list-data" xs={12}>
              <ActivityItemSettings profile="worker" />
            </GridItemTS>
          </TabContent>
          <TabContent value={ProfileTab.EQUIPMENTS}>
            <GridItemTS key="user-list-data" xs={12}>
              <ActivityItemSettings profile="equipment" />
            </GridItemTS>
          </TabContent>
        </TabSystem>
      </GridItemTS>
    </GridContainer>
  );
};

export default ActivityItemSettingsTabs;
